import { NgIf } from '@angular/common';
import { Component, Inject, Injectable } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { APP_CONFIG, Settings } from '../../config/settings';

export enum MessageDialogTypes {
    Error = 'Error',
    Warning = 'Warning',
    Information = 'Information'
}

@Component({
    template: ` <div class="nova__dialog__toolbar">
            <div class="nova__dialog__toolbar__title">{{ type }}</div>
            <div class="nova__dialog__toolbar__controls">
                <button
                    class="nova__button--icon"
                    (click)="close()"
                    ><mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon></button
                >
            </div>
        </div>
        <div
            mat-dialog-content
            class="nova__dialog__content">
            <p>
                <span>{{ message }}</span
                ><br />
                <span *ngIf="type === MessageDialogTypes.Error">
                    Please try again or contact <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a></span
                >
            </p>
            <mat-dialog-actions class="nova__dialog__content__actions">
                <button
                    mat-raised-button
                    color="primary"
                    (click)="close()"
                    >OK</button
                >
            </mat-dialog-actions>
        </div>`,
    standalone: true,
    imports: [MatIconModule, NgIf, MatDialogModule, MatButtonModule]
})
export class MessageDialogComponent {
    type: MessageDialogTypes;
    message: string;
    supportEmail: string;
    MessageDialogTypes = MessageDialogTypes;

    constructor(
        private readonly dialogRef: MatDialogRef<MessageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: { type: MessageDialogTypes; message: string },
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.type = data.type;
        this.message = data.message;
        this.supportEmail = settings.supportEmail;
    }

    close() {
        this.dialogRef.close();
    }
}

@Injectable({
    providedIn: 'root'
})
export class MessageDialogService {
    constructor(private readonly dialog: MatDialog) {}

    show(type: MessageDialogTypes, message: string | Error) {
        this.dialog.open(MessageDialogComponent, {
            minWidth: '480px',
            minHeight: '120px',
            data: { type: type, message: message },
            panelClass: 'nova__dialog'
        });
    }
}
